export default __webpack_public_path__ + "static/media/kanbanHover.449af169.svg";